<div class="tooltip" [ngClass]="['tooltip--'+position]" [style.left]="left + 'px'" [style.top]="top + 'px'">
    {{tooltip}}
</div>